import { DifficultyStats } from '../performanceDrawerData';
import { IStyles, pxToRem, pxTovW } from '@geneo2-web/shared-ui';
import {
  Drawer,
  Box,
  Typography,
  Button,
  DrawerProps,
  SxProps,
} from '@mui/material';
import { LevelRow } from '../../LevelRow';
import { DifficultyProgressItem } from '../../DifficultyProgressItem';

const drawerStyles = {
  card: {
    backgroundColor: '#fff',
    // boxShadow: '0 1px 6px rgba(0,0,0,0.05)',
  },
  cardHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 2,
  },
};

export const DifficultyBreakdownSection = ({
  data,
}: {
  data?: DifficultyStats[];
}) => {
  if (!data || data.length === 0) return null;

  const config = {
    easy: {
      label: 'Easy',
      color: '#22c55e',
      bg: '#dcfce7',
    },
    medium: {
      label: 'Medium',
      color: '#f59e0b',
      bg: '#fef3c7',
    },
    hard: {
      label: 'Hard',
      color: '#ef4444',
      bg: '#fecaca',
    },
  } as const;

  return (
    <Box>
      <Box sx={drawerStyles.cardHeader}>
        <Typography>📈</Typography>
        <Typography
          variant="cardText"
          sx={{
            fontFamily: 'Poppins',
            color: '#1e293b',
          }}
        >
          Difficulty Breakdown
        </Typography>
      </Box>

      <Box
        display="flex"
        flexDirection="column"
        gap={pxToRem(10)}
        mt={pxToRem(14)}
      >
        <DifficultyProgressItem data={data} />
      </Box>
    </Box>
  );
};
